import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { User, loadUsers, isExternalUser } from "./user-display";

interface Props {
    // user ids currently granted access (e.g. the allowed-people selection)
    userIds: string[];
}

// Small inline warning listing selected users whose email domain is outside
// the organization. Renders nothing when everyone is internal.
export default function ExternalDomainWarning({ userIds }: Props) {
    const [users, setUsers] = useState<Map<string, User>>(new Map());

    useEffect(() => {
        loadUsers()
            .then(list => setUsers(new Map(list.map(u => [u.id, u]))))
            .catch(() => {});
    }, []);

    const external = userIds
        .map(id => users.get(id))
        .filter((u): u is User => !!u && isExternalUser(u));

    if (external.length === 0) return null;

    return (
        <div className="m-external-warning">
            <AlertTriangle size={13} />
            <span>
                {external.length === 1 ? "This person is" : "These people are"} outside the
                organization: {external.map(u => u.email).join(", ")}
            </span>
        </div>
    );
}
